module.exports = __webpack_public_path__ + "img/button_award.7c222cda.png";